import { apiFetch } from './client';

export interface SignUploadInput {
  readonly filename: string;
  readonly mime: string;
  readonly byteSize: number;
}

export interface SignedUpload {
  readonly key: string;
  readonly uploadUrl: string;
  readonly method: 'PUT' | 'POST';
  readonly headers: Readonly<Record<string, string>>;
  readonly expiresAt: string;
}

export interface AssetRecord {
  readonly id: string;
  readonly key: string;
  readonly url: string;
  readonly mime: string;
  readonly byteSize: number;
  readonly width: number | null;
  readonly height: number | null;
  readonly createdAt: string;
}

export const assetsApi = {
  sign(input: SignUploadInput): Promise<SignedUpload> {
    return apiFetch<SignedUpload>('/assets/sign', { method: 'POST', body: input });
  },

  confirm(key: string): Promise<AssetRecord> {
    return apiFetch<AssetRecord>('/assets/confirm', { method: 'POST', body: { key } });
  },

  list(): Promise<AssetRecord[]> {
    return apiFetch<AssetRecord[]>('/assets');
  },

  remove(id: string): Promise<void> {
    return apiFetch<void>(`/assets/${id}`, { method: 'DELETE' });
  },

  async upload(file: File): Promise<AssetRecord> {
    const signed = await this.sign({
      filename: file.name,
      mime: file.type,
      byteSize: file.size,
    });
    const putResponse = await fetch(signed.uploadUrl, {
      method: signed.method,
      headers: signed.headers,
      body: file,
    });
    if (!putResponse.ok) {
      throw new Error(`Upload failed: ${putResponse.status} ${putResponse.statusText}`);
    }
    return this.confirm(signed.key);
  },
};
